import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import AuthService from "../../../components/AuthService";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";
import Template from "./cgu";

class Register extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.toggleCGU = this.toggleCGU.bind(this);
    this.handleNewsLetter = this.handleNewsLetter.bind(this);
    this.Auth = new AuthService();
  }

  toggleCGU(e) {
    e.preventDefault();
    this.setState({
      cgu: !this.state.cgu
    });
  }

  validateField(fieldName, value) {
    if (value == null) {
      return false;
    }
    switch (fieldName) {
      case "email":
        return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        break;
      case "password":
        return value.length >= 4;
        break;
      case "passwordCheck":
        return value == this.state.password;
        break;
      case "code":
        return value.length >= 4 && value.match(/^[^<>'\"/;`%?!&]*$/i);
        break;
      default:
        return true;
        break;
    }
  }

  notifyError(err) {
    toast.error(err);
  }

  notifySuccess(msg) {
    toast.success(msg);
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (
      !this.state ||
      !this.state.emailVerif ||
      !this.state.passwordVerif ||
      !this.state.passwordCheckVerif ||
      !this.state.codeVerif
    ) {
      this.notifyError(
        "Veuillez reessayer. Les informations entrées ne sont pas correctes ou manquantes."
      );
      return;
    }
    this.setState({ loading: true });
    this.Auth.register(
      this.state.email,
      this.state.password,
      this.state.code,
      this.state.newsletter ? 1 : 0
    )
      .then(res => {
        this.setState({ loading: false });
        this.props.history.replace("/login");
        this.notifySuccess(
          "Inscription réussie, tu peux désormais te connecter avec tes identifiants !"
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        this.notifyError(err.response.data);
      });
  }

  componentDidMount() {
    this.setState({
      emailVerif: false,
      passwordVerif: false,
      passwordCheckVerif: false,
      codeVerif: false,
      newsletter: false
    });
  }

  componentWillMount() {
    if (this.Auth.loggedIn()) {
      this.props.history.replace("/");
    }
  }

  handleLogin(e) {
    e.preventDefault();
    this.props.history.replace("/login");
  }

  handleNewsLetter(e) {
    if (e.target.checked) {
      this.setState({
        newsletter: true
      });
    } else {
      this.setState({
        newsletter: false
      });
    }
  }

  handleChange(e) {
    if (e.target.name == "email" || e.target.name == "name") {
      e.target.value = e.target.value.trim();
    }
    this.setState({
      [e.target.name]: e.target.value
    });
    let check = this.validateField(e.target.name, e.target.value);
    switch (e.target.name) {
      case "email":
        if (check) {
          this.setState({ emailVerif: true });
        } else {
          this.setState({ emailVerif: false });
        }
        break;

      case "password":
        if (check) {
          this.setState({ passwordVerif: true });
        } else {
          this.setState({ passwordVerif: false });
        }
        break;

      case "passwordCheck":
        if (check) {
          this.setState({ passwordCheckVerif: true });
        } else {
          this.setState({ passwordCheckVerif: false });
        }
        break;

      case "code":
        if (check) {
          this.setState({ codeVerif: true });
        } else {
          this.setState({ codeVerif: false });
        }
        break;
    }
  }

  render() {
    let content,
      loading,
      emailStyle,
      passwordStyle,
      passwordCheckStyle,
      codeStyle;
    if (!this.state) {
      content = (
        <ContentLoader
          height={200}
          width={400}
          speed={2}
          primaryColor={"#f3f3f3"}
          secondaryColor={"#ecebeb"}
        >
          <rect x="7" y="17" rx="4" ry="4" width="126.36" height="11.14" />
          <rect x="11" y="33.9" rx="3" ry="3" width="107.1" height="11.26" />
          <rect x="3" y="58" rx="3" ry="3" width="385" height="28.48" />
          <rect x="3" y="95" rx="3" ry="3" width="385" height="28.48" />
          <rect x="9" y="143.9" rx="0" ry="0" width="105" height="24" />
          <rect x="310" y="153.9" rx="0" ry="0" width="78" height="9" />
        </ContentLoader>
      );
    } else {
      if (this.state.loading) {
        loading = (
          <img
            src="/img/loading_icon.gif"
            style={{
              height: "auto",
              width: "auto",
              maxWidth: 70 + "px",
              maxHeight: 70 + "px"
            }}
          />
        );
      }

      if (this.state.emailVerif) {
        emailStyle = { borderColor: "green" };
      }

      if (this.state.codeVerif) {
        codeStyle = { borderColor: "green" };
      }

      if (this.state.passwordVerif) {
        passwordStyle = { borderColor: "green" };
      }

      if (this.state.passwordCheckVerif) {
        passwordCheckStyle = { borderColor: "green" };
      }

      content = (
        <CardBody>
          <h1>Tableau de bord Happy Quest</h1>
          <p className="text-muted">Inscription</p>
          <form onSubmit={this.handleFormSubmit}>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-user" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Prénom (optionel)"
                onChange={this.handleChange}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>@</InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name="email"
                id="email"
                placeholder="Email"
                style={emailStyle}
                onChange={this.handleChange}
                required
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-lock" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                name="password"
                id="password"
                placeholder="Mot de passe"
                style={passwordStyle}
                onChange={this.handleChange}
                required
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-lock" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="password"
                name="passwordCheck"
                id="passwordCheck"
                placeholder="Vérification mot de passe"
                style={passwordCheckStyle}
                onChange={this.handleChange}
                required
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="fa fa-users" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name="code"
                id="code"
                placeholder="Code entreprise"
                style={codeStyle}
                onChange={this.handleChange}
                required
              />
            </InputGroup>
            <FormGroup row>
              <Col md="9">
                <FormGroup check className="checkbox">
                  <Input
                    onClick={this.handleNewsLetter}
                    className="form-check-input"
                    type="checkbox"
                    id="newsletter"
                    name="newsletter"
                    value="1"
                  />
                  <Label check className="form-check-label" htmlFor="checkbox1">
                    J'accepte de recevoir la newsletter
                  </Label>
                </FormGroup>
                <FormGroup check className="checkbox">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    id="cgu"
                    name="cgu"
                    required
                  />
                  <Label check className="form-check-label" htmlFor="checkbox1">
                    J'accepte les
                    <Button color="link" onClick={this.toggleCGU} style={{padding:"0px 4px"}}>CGU</Button>
                  </Label>
                </FormGroup>
              </Col>
            </FormGroup>
            <Row>
              <Col xs="6">
                <Button type="submit" color="primary">
                  Créer un compte
                </Button>
                {loading}
              </Col>
              <Col xs="6" className="text-right">
                <Button
                  id="login"
                  color="link"
                  className="px-0"
                  onClick={this.handleLogin}
                >
                  Se connecter
                </Button>
              </Col>
            </Row>
          </form>

          <Modal
            isOpen={this.state.cgu}
            toggle={this.toggleCGU}
            className={"modal-lg modal-warning " + this.props.className}
          >
            <ModalHeader toggle={this.toggleCGU}>Les CGU</ModalHeader>
            <ModalBody>
              <Template />
            </ModalBody>
            <ModalFooter>
              <Button color="warning" onClick={this.toggleCGU}>
                OK !
              </Button>
            </ModalFooter>
          </Modal>
        </CardBody>
      );
    }
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer />
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <Card className="p-4">{content}</Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js